// extracted by mini-css-extract-plugin
export default {"recipesContainer":"recipes_recipesContainer__BcH0z"};